package uk.co.nickthecoder.kyd.shapes

import uk.co.nickthecoder.kyd.util.Vector2

class Polygon(points: Iterable<Vector2>) : SimpleShape(points) {

    /**
     * [index] is NOT bounded by the size of [points]. e.g. `get(-1) === `points.last()` and
     * `get(points.size)` === `points.first()`
     */
    override fun get(index: Int): Vector2 {
        val remainder = index.rem(points.size)
        return if (remainder < 0) {
            points[points.size + remainder]
        } else {
            points[remainder]
        }
    }

    /**
     * Creates a [Line] by cutting the polygon as the given [index].
     * The start and the end points will be the same.
     */
    fun openAtIndex(index: Int): Line {
        if (index == 0 || index == points.size) {
            return Line(points)
        } else {
            val splitPoints = mutableListOf<Vector2>()
            splitPoints.addAll(points.subList(index, points.size))
            splitPoints.addAll(points.subList(0, index + 1))
            return Line(splitPoints)
        }
    }

    override fun createFillMesh(shapeAppearance: ShapeAppearance): Mesh {
        val triangles = triangulate(points)
        return Mesh(MeshBuffer.fromTriangles(triangles))
    }

    override fun createStrokeMesh(shapeAppearance: ShapeAppearance): Mesh {
        return StrokeMesh().apply {
            insideThickness = shapeAppearance.strokeWidth * (1 - shapeAppearance.strokeRatio)
            outsideThickness = shapeAppearance.strokeWidth * shapeAppearance.strokeRatio
            joinStyle = shapeAppearance.joinStyle
            includeStrokeGradient = shapeAppearance.stroke.hasAcrossAttribute
        }.createStrokeMesh(points, isClosed = true)
    }

}
